module.exports = __webpack_public_path__ + "img/4.e4228ff3.png";